import { Toast } from "primereact/toast";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { CART_PAYMENT_STEP_PARAM } from "../../constants/app-constants";
import { DISCOUNT_TYPES } from "../../constants/discount-types";
import { PAYMENT_METHODS } from "../../constants/payment-methods";
import { PRODUCT_TYPE_CODES, PRODUCT_TYPES } from "../../constants/product-types";
import { convertCurrency } from "../../helpers/currency";
import {
  getI18nLanguageFromLocalStorage,
  getShoppingCartPaymentSuccessLocalStorage,
  getShoppingCartStateInLocalStorage,
removeShoppingCartPaymentSuccessLocalStorage,
  removeShoppingCartStateFromLocalStorage,
  setShoppingCartStateInLocalStorage,
} from "../../helpers/localStorageHelper";
import useCurrency from "../../hook/useCurrency";
import { translate } from "../../localization/translateService";
import { getBundleDiscounts } from "../../services/bundleDiscountService";
import { getProductTypes } from "../../services/productTypeService";
import { checkout, getStudentOrderInfo, updateProductQuantityInShoppingCart, getQuickBuyItem } from "../../services/shoppingCartService";
import { getShoppingCart, getShoppingCartHubConnection, initializeShoppingCartConnection, onShoppingCartUpdated, removeShoppingCartItem } from "../../services/signalRService";
import { ErrorTemplate, SuccessTemplate } from "../common/ToastMessage/Template";
import Payment from "./Payment";
import ShoppingCart from "./ShoppingCart";
import { COUPON_TARGETS } from "../../constants/coupon-targets";
import { normalizePaymentOptions } from "../../helpers/paymentUtils";
import { FRACTIONAL_CURRENCIES } from "../../constants/currency";
import { SDK_URLS } from "../../constants/sdk-constants";
import { SHOPPING_CART_STEPS } from "../../constants/shopping-cart-constants";
import { ERROR_CODES } from "../../constants/error-codes";
import AuthenticationService from "../../services/authService";
import { usePassText } from "../Passes/passI18n";
import KeduLoading from "../loading/KeduLoading";

export default function PaymentProcessing({ props }) {
  const passText = usePassText();
  const currentUser$ = AuthenticationService.instance().getCurrentUser$();
  const [currentUser, setCurrentUser] = useState(null);
  const MIN_STEP = 1;
  const MAX_STEP = 2;
  const shoppingCartRef = useRef();
  const didMountRef = useRef(false);
  const [lang, setLanguage] = useState("");
  const [translations, setTranslations] = useState({
    step: "",
    shoppingCartLabel: "",
    paymentProgress: "",
    paymentCompleted: "",
    emptyCart: "",
    productLabel: "",
    itemsLabel: "",
    selectAllLabel: "",
    starsLabel: "",
    chooseBundleDiscount: "",
    orderSummary: "",
    allOrders: "",
    total: "",
    payNowButton: "",
    orderInformation: "",
    studentNameLabel: "",
    studentEmailLabel: "",
    enterStudentNamePlaceholder: "",
    enterStudentEmailPlaceholder: "",
    noteLabel: "",
    saveForNextTimeLabel: "",
    orderedProductsLabel: "",
    sessionLabel: "",
    selectPaymentMethodLabel: "",
    stripeDescription: "",
    vnpayDescription: "",
    onepayDescription: "",
    eximbayDescription: "",
    paypalDescription: "",
    portoneDescription: "",
    paymentwallDescription: "",
    selectCouponLabel: "",
    selectButtonLabel: "",
    notAppliedLabel: "",
    enterPromotionCodeLabel: "",
    promotionCodeWarning: "",
    applyButtonLabel: "",
    enterCodeHerePlaceholder: "",
    orderDetailsLabel: "",
    discountAmountLabel: "",
    totalPaymentAmountLabel: "",
    reviewOrderAndAgreeToPaymentLabel: "",
    payButtonLabel: "",
    paymentSuccessfulLabel: "",
    yourInvoiceLabel: "",
    informationLabel: "",
    orderIdLabel: "",
    dateLabel: "",
    paymentMethodLabel: "",
    paymentHistoryButtonLabel: "",
    startLearningButtonLabel: "",
    processPaymentFailMessage: "",
    invalidCouponCode: "",
    minimumOrderAmountLabel: "",
    hereLabel: "",
    couponNotApplicable: "",
    systemDiscountLabel: "",
    paymentErrorMessage: "",
    noPaymentMethodsLabel: "",
    backButtonLabel: "",
    selectADay: "",
    chooseATime: "",
    available: "",
    booked: "",
    selectedSchedules: "",
    clearAll: "",
    canAddMore: "",
    morning: "",
    afternoon: "",
    evening: "",
    confirmSchedule: "",
    timezoneKorea: "",
    timezoneVietnam: "",
    timezoneUs: "",
    scheduleConfirmedTitle: "",
    scheduleConfirmedMessage: "",
    scheduleConfirmedErrorTitle: "",
    scheduleConfirmedErrorMessage: "",
    updateScheduleButtonLabel: "",
    scheduleCancelledTitle: "",
    scheduleCancelledMessage: "",
    scheduleCancelledErrorTitle: "",
    scheduleCancelledErrorMessage: "",
    waitingForPaymentLabel: "",
  });

  const loadTranslations = async () => {
    const step = await translate("SHOPPING_CARTS.LABELS.STEP");
    const shoppingCartLabel = await translate("SHOPPING_CARTS.LABELS.SHOPPING_CART");
    const paymentProgress = await translate("SHOPPING_CARTS.LABELS.PAYMENT_PROGRESS");
    const paymentCompleted = await translate("SHOPPING_CARTS.LABELS.PAYMENT_COMPLETED");
    const emptyCart = await translate("SHOPPING_CARTS.LABELS.EMPTY_CART");
    const productLabel = await translate("SHOPPING_CARTS.LABELS.PRODUCT");
    const itemsLabel = await translate("SHOPPING_CARTS.LABELS.ITEMS");
    const selectAllLabel = await translate("SHOPPING_CARTS.LABELS.SELECT_ALL");
    const starsLabel = await translate("SHOPPING_CARTS.LABELS.STARS");
    const chooseBundleDiscount = await translate("SHOPPING_CARTS.PLACEHOLDERS.CHOOSE_BUNDLE_DISCOUNT");
    const orderSummary = await translate("SHOPPING_CARTS.LABELS.ORDER_SUMMARY");
    const allOrders = await translate("SHOPPING_CARTS.LABELS.ALL_ORDERS");
    const total = await translate("SHOPPING_CARTS.LABELS.TOTAL");
    const payNowButton = await translate("SHOPPING_CARTS.BUTTON_LABELS.PAY_NOW");
    const orderInformation = await translate("SHOPPING_CARTS.LABELS.ORDER_INFORMATION");
    const studentNameLabel = await translate("SHOPPING_CARTS.LABELS.STUDENT_NAME");
    const studentEmailLabel = await translate("SHOPPING_CARTS.LABELS.STUDENT_EMAIL");
    const enterStudentNamePlaceholder = await translate("SHOPPING_CARTS.PLACEHOLDERS.ENTER_STUDENT_NAME");
    const enterStudentEmailPlaceholder = await translate("SHOPPING_CARTS.PLACEHOLDERS.ENTER_STUDENT_EMAIL");
    const noteLabel = await translate("SHOPPING_CARTS.LABELS.NOTE");
    const saveForNextTimeLabel = await translate("SHOPPING_CARTS.LABELS.SAVE_FOR_NEXT_TIME");
    const orderedProductsLabel = await translate("SHOPPING_CARTS.LABELS.ORDERED_PRODUCTS");
    const sessionLabel = await translate("SHOPPING_CARTS.LABELS.SESSION");
    const selectPaymentMethodLabel = await translate("SHOPPING_CARTS.LABELS.SELECT_PAYMENT_METHOD");
    const stripeDescription = await translate("SHOPPING_CARTS.LABELS.STRIPE_DESCRIPTION");
    const vnpayDescription = await translate("SHOPPING_CARTS.LABELS.VNPAY_DESCRIPTION");
    const onepayDescription = await translate("SHOPPING_CARTS.LABELS.ONEPAY_DESCRIPTION");
    const eximbayDescription = await translate("SHOPPING_CARTS.LABELS.EXIMBAY_DESCRIPTION");
    const paypalDescription = await translate("SHOPPING_CARTS.LABELS.PAYPAL_DESCRIPTION");
    const portoneDescription = await translate("SHOPPING_CARTS.LABELS.PORTONE_DESCRIPTION");
    const paymentwallDescription = await translate("SHOPPING_CARTS.LABELS.PAYMENTWALL_DESCRIPTION");
    const selectCouponLabel = await translate("SHOPPING_CARTS.LABELS.SELECT_COUPON");
    const selectButtonLabel = await translate("SHOPPING_CARTS.BUTTON_LABELS.SELECT");
    const notAppliedLabel = await translate("SHOPPING_CARTS.LABELS.NOT_APPLIED");
    const enterPromotionCodeLabel = await translate("SHOPPING_CARTS.LABELS.ENTER_PROMOTION_CODE");
    const promotionCodeWarning = await translate("SHOPPING_CARTS.LABELS.PROMOTION_CODE_WARNING");
    const applyButtonLabel = await translate("SHOPPING_CARTS.BUTTON_LABELS.APPLY");
    const enterCodeHerePlaceholder = await translate("SHOPPING_CARTS.PLACEHOLDERS.ENTER_CODE_HERE");
    const orderDetailsLabel = await translate("SHOPPING_CARTS.LABELS.ORDER_DETAILS");
    const discountAmountLabel = await translate("SHOPPING_CARTS.LABELS.DISCOUNT_AMOUNT");
    const totalPaymentAmountLabel = await translate("SHOPPING_CARTS.LABELS.TOTAL_PAYMENT_AMOUNT");
    const reviewOrderAndAgreeToPaymentLabel = await translate("SHOPPING_CARTS.LABELS.REVIEW_ORDER_AND_AGREE_TO_PAYMENT");
    const payButtonLabel = await translate("SHOPPING_CARTS.BUTTON_LABELS.PAY");
    const paymentSuccessfulLabel = await translate("SHOPPING_CARTS.LABELS.PAYMENT_SUCCESSFUL");
    const yourInvoiceLabel = await translate("SHOPPING_CARTS.LABELS.YOUR_INVOICE");
    const informationLabel = await translate("SHOPPING_CARTS.LABELS.INFORMATION");
    const orderIdLabel = await translate("SHOPPING_CARTS.LABELS.ORDER_ID");
    const dateLabel = await translate("SHOPPING_CARTS.LABELS.DATE");
    const paymentMethodLabel = await translate("SHOPPING_CARTS.LABELS.PAYMENT_METHOD");
    const paymentHistoryButtonLabel = await translate("SHOPPING_CARTS.BUTTON_LABELS.PAYMENT_HISTORY");
    const startLearningButtonLabel = await translate("SHOPPING_CARTS.BUTTON_LABELS.START_LEARNING");
    const processPaymentFailMessage = await translate("API_MESSAGES.EXCEPTIONS.FAILED_TO_PROCESS_PAYMENT");
    const invalidCouponCode = await translate("API_MESSAGES.EXCEPTIONS.INVALID_COUPON_CODE");
    const couponNotApplicable = await translate("API_MESSAGES.EXCEPTIONS.COUPON_NOT_APPLICABLE");
    const cancelButtonLabel = await translate("BUTTON.CANCEL");
    const confirmButtonLabel = await translate("BUTTON.CONFIRM");
    const removeTicketLabel = await translate("SHOPPING_CARTS.LABELS.REMOVE_TICKET");
    const removeItemLabel = await translate("SHOPPING_CARTS.LABELS.REMOVE_ITEM");
    const removeTicketSuccessLabel = await translate("SHOPPING_CARTS.LABELS.REMOVE_TICKET_SUCCESS");
    const removeItemSuccessLabel = await translate("SHOPPING_CARTS.LABELS.REMOVE_ITEM_SUCCESS");
    const removeCartItemHeader = await translate("SHOPPING_CARTS.LABELS.REMOVE_ITEM_HEADER");
    const minimumOrderAmountLabel = await translate("SHOPPING_CARTS.LABELS.MINIMUM_ORDER_AMOUNT");
    const hereLabel = await translate("SHOPPING_CARTS.LABELS.HERE");
    const systemDiscountLabel = await translate("SHOPPING_CARTS.LABELS.SYSTEM_DISCOUNT");
    const paymentErrorMessage = await translate("API_MESSAGES.EXCEPTIONS.PAYMENT_ERROR");
    const noPaymentMethodsLabel = await translate("SHOPPING_CARTS.LABELS.NO_PAYMENT_METHODS");
    const backButtonLabel = await translate("BUTTON.BACK_TO_LIST");
    const selectADay = await translate("SHOPPING_CARTS.LABELS.SELECT_A_DAY");
    const chooseATime = await translate("SHOPPING_CARTS.LABELS.CHOOSE_A_TIME");
    const available = await translate("SHOPPING_CARTS.LABELS.AVAILABLE");
    const booked = await translate("SHOPPING_CARTS.LABELS.BOOKED");
    const selectedSchedules = await translate("SHOPPING_CARTS.LABELS.SELECTED_SCHEDULES");
    const clearAll = await translate("SHOPPING_CARTS.LABELS.CLEAR_ALL");
    const canAddMore = await translate("SHOPPING_CARTS.LABELS.CAN_ADD_MORE");
    const morning = await translate("SHOPPING_CARTS.LABELS.MORNING");
    const afternoon = await translate("SHOPPING_CARTS.LABELS.AFTERNOON");
    const evening = await translate("SHOPPING_CARTS.LABELS.EVENING");
    const confirmSchedule = await translate("SHOPPING_CARTS.LABELS.CONFIRM_SCHEDULE");
    const timezoneKorea = await translate("SHOPPING_CARTS.LABELS.TIMEZONE_KOREA");
    const timezoneVietnam = await translate("SHOPPING_CARTS.LABELS.TIMEZONE_VIETNAM");
    const timezoneUs = await translate("SHOPPING_CARTS.LABELS.TIMEZONE_US");
    const scheduleConfirmedTitle = await translate("SHOPPING_CARTS.LABELS.SCHEDULE_CONFIRMED_TITLE");
    const scheduleConfirmedMessage = await translate("SHOPPING_CARTS.LABELS.SCHEDULE_CONFIRMED_MESSAGE");
    const scheduleConfirmedErrorTitle = await translate("SHOPPING_CARTS.LABELS.SCHEDULE_CONFIRMED_ERROR_TITLE");
    const scheduleConfirmedErrorMessage = await translate("SHOPPING_CARTS.LABELS.SCHEDULE_CONFIRMED_ERROR_MESSAGE");
    const updateScheduleButtonLabel = await translate("SHOPPING_CARTS.LABELS.UPDATE_SCHEDULE");
    const scheduleCancelledTitle = await translate("SHOPPING_CARTS.LABELS.SCHEDULE_CANCELLED_TITLE");
    const scheduleCancelledMessage = await translate("SHOPPING_CARTS.LABELS.SCHEDULE_CANCELLED_MESSAGE");
    const scheduleCancelledErrorTitle = await translate("SHOPPING_CARTS.LABELS.SCHEDULE_CANCELLED_ERROR_TITLE");
    const scheduleCancelledErrorMessage = await translate("SHOPPING_CARTS.LABELS.SCHEDULE_CANCELLED_ERROR_MESSAGE");
    const waitingForPaymentLabel = await translate("SHOPPING_CARTS.LABELS.WAITING_FOR_PAYMENT");
    setTranslations({
      step,
      shoppingCartLabel,
      paymentProgress,
      paymentCompleted,
      emptyCart,
      productLabel,
      itemsLabel,
      selectAllLabel,
      starsLabel,
      chooseBundleDiscount,
      orderSummary,
      allOrders,
      total,
      payNowButton,
      orderInformation,
      studentNameLabel,
      studentEmailLabel,
      enterStudentNamePlaceholder,
      enterStudentEmailPlaceholder,
      noteLabel,
      saveForNextTimeLabel,
      orderedProductsLabel,
      sessionLabel,
      selectPaymentMethodLabel,
      stripeDescription,
      onepayDescription,
      vnpayDescription,
      eximbayDescription,
      paypalDescription,
      portoneDescription,
      paymentwallDescription,
      selectCouponLabel,
      selectButtonLabel,
      notAppliedLabel,
      enterPromotionCodeLabel,
      promotionCodeWarning,
      applyButtonLabel,
      enterCodeHerePlaceholder,
      orderDetailsLabel,
      discountAmountLabel,
      totalPaymentAmountLabel,
      reviewOrderAndAgreeToPaymentLabel,
      payButtonLabel,
      paymentSuccessfulLabel,
      yourInvoiceLabel,
      informationLabel,
      orderIdLabel,
      dateLabel,
      paymentMethodLabel,
      paymentHistoryButtonLabel,
      startLearningButtonLabel,
      processPaymentFailMessage,
      invalidCouponCode,
      couponNotApplicable,
      cancelButtonLabel,
      confirmButtonLabel,
      removeTicketLabel,
      removeItemLabel,
      removeTicketSuccessLabel,
      removeItemSuccessLabel,
      removeCartItemHeader,
      minimumOrderAmountLabel,
      hereLabel,
      systemDiscountLabel,
      paymentErrorMessage,
      noPaymentMethodsLabel,
      backButtonLabel,
      selectADay,
      chooseATime,
      available,
      booked,
      selectedSchedules,
      clearAll,
      canAddMore,
      morning,
      afternoon,
      evening,
      confirmSchedule,
      timezoneKorea,
      timezoneVietnam,
      timezoneUs,
      scheduleConfirmedTitle,
      scheduleConfirmedMessage,
      scheduleConfirmedErrorTitle,
      scheduleConfirmedErrorMessage,
      updateScheduleButtonLabel,
      scheduleCancelledTitle,
      scheduleCancelledMessage,
      scheduleCancelledErrorTitle,
      scheduleCancelledErrorMessage,
      waitingForPaymentLabel,
    });
  };

  useEffect(() => {
    const language = getI18nLanguageFromLocalStorage();
    setLanguage(language);
    loadTranslations();
  }, [lang]);

  // Check authentication and redirect if not logged in
  useEffect(() => {
    const subscription = currentUser$.subscribe((user) => {
      setCurrentUser(user);
      if (!user) {
        window.location.href = props.loginUrl;
      }
    });
    return () => subscription.unsubscribe();
  }, [props.loginUrl, currentUser$]);

  const { display, ratesData, defaultCurrency, target } = useCurrency();
  
  const steps = [
    { id: 1, label: translations.shoppingCartLabel },
    { id: 2, label: translations.paymentProgress },
    { id: 3, label: translations.paymentCompleted },
  ];

  const defaultCoupon = useMemo(() => {
    if (!translations?.notAppliedLabel) return null;

    return {
      id: 0,
      discountAmount: 0,
      name: translations.notAppliedLabel,
      description: "",
      code: "",
      expiredAt: null,
    };
  }, [translations]);

  const errorToast = useRef(null);
  const isCartRestored = useRef(false);
  const quickBuyErrorShown = useRef(false);
  const [cartDetail, setCartDetail] = useState({
    shoppingCartItems: [],
  });

  const [studentInfo, setStudentInfo] = useState({
    recipientName: null,
    email: null,
    note: null,
    saveInfo: true,
  });

  const [currentStep, setCurrentStep] = useState(SHOPPING_CART_STEPS.SHOPPING_CART);
  const [productTypes, setProductTypes] = useState([]);
  const [bundleDiscounts, setBundleDiscounts] = useState([]);
  const [sessionCount, setSessionCount] = useState(1);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const selectedProductIdsRef = useRef([]);
  const [isQuickBuy, setIsQuickBuy] = useState(false);

  const getProductTypeClass = useCallback(
    (id) => {
      const productType = productTypes.find((p) => p.id === id);
      return PRODUCT_TYPES[productType?.code]?.class ?? "";
    },
    [productTypes]
  );

  const getProductTypeTag = useCallback(
    (id) => {
      const productType = productTypes.find((p) => p.id === id);
      return PRODUCT_TYPES[productType?.code]?.tag ?? "";
    },
    [productTypes]
  );

  // Generalized product type checker
  const isProductType = useCallback(
    (id, typeCode) => {
      if (productTypes.length === 0) return false;
      return productTypes.find((p) => p.id === id)?.code === typeCode;
    },
    [productTypes]
  );

  const getProductNote = useCallback(
    (item) => {
      if (productTypes.length === 0) return "";
      const productType = productTypes.find((p) => p.id === item.productTypeId);

      switch (productType?.code) {
        case PRODUCT_TYPE_CODES.VOD_COURSE:
          return props.note.vodNote.replace(/{{\s*note_value\s*}}/g, item.noteValue);

        case PRODUCT_TYPE_CODES.REAL_TIME_LECTURE:
          return props.note.realTimeLectureNote;

        case PRODUCT_TYPE_CODES.EVENT:
          return props.note.eventNote.replace(/{{\s*note_value\s*}}/g, item.noteValue);

        case PRODUCT_TYPE_CODES.PACKAGE:
          return props.note.packageNote.replace(/{{\s*note_value\s*}}/g, item.noteValue);

        case PRODUCT_TYPE_CODES.VOD_SERIES:
          return props.note.vodSeriesNote.replace(/{{\s*note_value\s*}}/g, item.noteValue);

        case PRODUCT_TYPE_CODES.DOTORE_PASS:
          return item.noteValue > 0 ? passText("DOTORE_PASS.BANNER.VALIDITY_DAYS", { days: item.noteValue }) : "";

        default:
          return "";
      }
    },
    [productTypes, props.note.vodNote, props.note.realTimeLectureNote, props.note.eventNote, props.note.packageNote, props.note.vodSeriesNote, passText]
  );

  const getBundleDiscountLabel = (item) => {
    const found = item.bundleDiscountOptions?.find((option) => option.value === item.selectedBundleId);
    return found ? 
      { 
        originalLabel: found.originalLabel,
        discountLabel: found.label,
      } : 
      { 
        originalLabel: null, 
        discountLabel: null 
      };
  };

  const handleDelete = async (productItem, isNeedConfirm = true) => {
    selectedProductIdsRef.current = cartDetail.shoppingCartItems.filter((item) => item.isSelected && item.productId !== productItem?.productId).map((item) => item.productId);
    try {
      await removeShoppingCartItem(productItem?.productId);
      if (isNeedConfirm) {
        shoppingCartRef.current?.handleCloseConfirmDeleteCartItemDialog();
        showSuccessToast(
          isProductType(productItem?.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE)
            ? translations.removeTicketSuccessLabel.replace("{{name}}", productItem?.name)
            : translations.removeItemSuccessLabel.replace("{{title}}", productItem?.name)
        );
      }
    } catch (error) {}
  };

  const requestPayAsync = (IMP, requestData) => {
    return new Promise((resolve, reject) => {
      IMP.request_pay(requestData, (response) => {
        if (response.success) {
          resolve(response);
        } else {
          const err = new Error(`IMP Error: ${response.error_msg}`);
          err.code = response?.error_code || ERROR_CODES.IMP_REQUEST_FAILED;
          reject(err);
        }
      });
    });
  };

  const loadScript = (src, checkReady) => {
    return new Promise((resolve, reject) => {
      if (checkReady()) {
        resolve();
        return;
      }

      const script = document.createElement("script");
      script.src = src;
      script.async = true;

      script.onload = () => {
        if (checkReady()) {
          resolve();
        } else {
          const err = new Error(`Script ${src} loaded but SDK not ready`);
          err.code = ERROR_CODES.SDK_NOT_READY;
          err.src = src;
          reject(err);
        }
      };

      script.onerror = () => {
        const err = new Error(`Failed to load script ${src}`);
        err.code = ERROR_CODES.SCRIPT_LOAD_FAILED;
        err.src = src;
        reject(err);
      };

      document.body.appendChild(script);
    });
  };

  const ensurePortOne = async () => {
    await loadScript(
      SDK_URLS.PORTONE,
      () => !!window.PortOne
    );
    return window.PortOne;
  };

  const ensureIMP = async () => {
    await loadScript(
      SDK_URLS.IAMPORT,
      () => !!window.IMP
    );
    return window.IMP;
  };

  const ensureIMPInit = async (customerId) => {
    const IMP = await ensureIMP();

    if (IMP.__initializedCustomerId !== customerId) {
      IMP.init(customerId);
      IMP.__initializedCustomerId = customerId;
    }

    return IMP;
  };

  const handlePaymentSubmit = async () => {
    removeShoppingCartPaymentSuccessLocalStorage();
    const { subTotal, discountTotal, itemDiscountMap, finalTotal } = calculatePrice();

    const isFreeCheckout = finalTotal <= 0;

    const { language: normalizedLang, currency: normalizedCurrency } = isFreeCheckout
      ? { language: lang, currency: target }
      : normalizePaymentOptions(selectedPaymentMethod, lang, target);
    const convertedSubTotal = convertCurrency(subTotal, target, normalizedCurrency, ratesData);
    const convertedDiscountTotal = convertCurrency(discountTotal, target, normalizedCurrency, ratesData);
    const convertedFinalTotal = convertCurrency(finalTotal, target, normalizedCurrency, ratesData);

    const formData = new FormData();
    formData.append("paymentMethod", isFreeCheckout ? PAYMENT_METHODS.FREE : selectedPaymentMethod);
    formData.append("paymentOption", isFreeCheckout ? "" : "card");
    formData.append("studentName", studentInfo.recipientName);
    formData.append("studentEmail", studentInfo.email);
    formData.append("saveInfo", studentInfo.saveInfo);
    formData.append("note", studentInfo.note);
    formData.append("subTotal", convertedSubTotal.toLocaleString("en-US", { useGrouping: false }));
    formData.append("discountTotal", convertedDiscountTotal.toLocaleString("en-US", { useGrouping: false }));
    formData.append("currencyCode", normalizedCurrency);
    formData.append("language", normalizedLang);

    const products = cartDetail.shoppingCartItems
      .filter((item) => item.isSelected)
      .map((item) => {
        const quantity = isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE)
          ? sessionCount
          : (item.selectedBundleId != null ? bundleDiscounts.find((bd) => bd.id === item.selectedBundleId)?.numberTicket || 1 : 1);

        const rawPrice = item.isPassCovered
          ? 0
          : isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE)
            ? convertCurrency(getRealTimeLecturePrice(item).discountPrice, item.currencyCode ?? defaultCurrency, normalizedCurrency, ratesData)
            : convertCurrency(item.discountPrice, item.currencyCode ?? defaultCurrency, normalizedCurrency, ratesData);

        const originalPrice = parseFloat(rawPrice.toLocaleString("en-US", { useGrouping: false }));
        const discountedPrice = convertCurrency(itemDiscountMap[item.id]?.discount || 0, target, normalizedCurrency, ratesData);
        const finalTotal = parseFloat((originalPrice - discountedPrice).toLocaleString("en-US", { useGrouping: false }));

        return {
          productId: item.productId,
          productName: item.name,
          quantity: quantity,
          finalTotal: finalTotal,
          subTotal: originalPrice,
        };
      });

    // Build formData as before, only products with coupon info
    formData.append("products", JSON.stringify(products));

    if (selectedCoupon && selectedCoupon.id !== 0) {
      formData.append("couponIds", selectedCoupon.id);
    }

    const response = await checkout(formData);

    // Free checkout: order is already completed, redirect to receipt
    if (response.isFreeCheckout) {
      removeShoppingCartStateFromLocalStorage();
      window.location.href = `/${lang}/receipt/${response.orderNumber}`;
      return;
    }

    setShoppingCartStateInLocalStorage({
      orderNumber: response.orderNumber,
      cartDetail: cartDetail,
      studentInfo: studentInfo,
      selectedCoupon: selectedCoupon,
      selectedPaymentMethod: selectedPaymentMethod,
      transactionId: response.transactionId,
    });

    if (selectedPaymentMethod === PAYMENT_METHODS.IMP_PAYPAL) {
      const PortOne = await ensurePortOne();
      const redirectUrl = `${process.env.API_ENDPOINT}/${lang}/payment-return?transactionId=${response.transactionId}&code=${selectedPaymentMethod}&paymentId=${response.orderNumber}`;
      let totalAmount = convertedFinalTotal;
      if (FRACTIONAL_CURRENCIES.includes(normalizedCurrency)) {
        totalAmount = Math.round(totalAmount * 100);
      }
      const paypalRequestData = {
        storeId: response.storeId,
        channelKey: response.channelKey,
        paymentId: response.orderNumber,
        orderName: response.orderNumber,
        totalAmount: totalAmount,
        currency: normalizedCurrency,
        payMethod: "PAYPAL",
        redirectUrl: redirectUrl,
        noticeUrls: [`${process.env.API_ENDPOINT}/api/payment-callback/imp/callback`],
        customer: {
          email: studentInfo.email || "",
          fullName: studentInfo.recipientName || "",
        }
      };

      let portOneResponse = await PortOne.requestPayment(paypalRequestData);
      if (portOneResponse.code) {
        const err = new Error(`PortOne Error: ${portOneResponse.message}`);
        err.code = portOneResponse.code;
        err.raw = portOneResponse;
        throw err;
      }
      window.location.href = redirectUrl;
    } else if (response.customerId) {
      const IMP = await ensureIMPInit(response.customerId);
      const redirectUrl = `${process.env.API_ENDPOINT}/${lang}/payment-return?transactionId=${response.transactionId}&code=${selectedPaymentMethod}`;
      const baseRequestData = {
        channelKey: response.channelKey,
        merchant_uid: response.orderNumber,
        name: response.orderNumber,
        amount: convertedFinalTotal,
        language: normalizedLang,
        buyer_email: studentInfo.email || "",
        m_redirect_url: redirectUrl,
        currency: normalizedCurrency,
        popup: true,
        buyer_addr: "",
        buyer_postcode: "",
        buyer_tel: "",
        notice_url: `${process.env.API_ENDPOINT}/api/payment-callback/imp/callback`,
        pay_method: "card"
      };
      
      const requestData = {
        ...baseRequestData,
      };

      const impResponse = await requestPayAsync(IMP, requestData);
      const url = new URL(redirectUrl);
      url.searchParams.append("imp_uid", impResponse.imp_uid);
      url.searchParams.append("merchant_uid", impResponse.merchant_uid);
      const finalRedirectUrl = url.toString();
      window.location.href = finalRedirectUrl;
    }
    else {
      window.location.href = response.paymentUrl;
    }
  };

  const showErrorToast = (message) => {
    errorToast.current.show({
      severity: "error",
      detail: message,
      life: 3000,
      content: (props) => ErrorTemplate(props),
    });
  };

  const showSuccessToast = (message) => {
    errorToast.current.show({
      severity: "success",
      detail: message,
      life: 3000,
      content: (props) => SuccessTemplate(props),
    });
  };

  const toggleProductSelection = (id) => {
    setCartDetail((prev) => {
      const updatedItems = prev.shoppingCartItems.map((item) => (item.id === id ? { ...item, isSelected: !item.isSelected } : item));
      return {
        ...prev,
        shoppingCartItems: updatedItems,
      };
    });
  };

  const handleBundleChange = (id, value) => {
    const productId = cartDetail.shoppingCartItems.find((item) => item.id === id)?.productId;
    const bundleDiscount = (bundleDiscounts ?? []).find((bd) => bd.id === value);
    if (bundleDiscount && productId) {
      updateProductQuantityInShoppingCart(productId, bundleDiscount.numberTicket);
    }
    setCartDetail((prev) => {
      const updatedItems = prev.shoppingCartItems.map((item) => (item.id === id ? 
        { ...item, 
          selectedBundleId: value, 
          discountPercent: bundleDiscount?.discountPercentage || 0,
          quantity: bundleDiscount?.numberTicket || 1
        } : 
        item));
        const newCartDetail = {
          ...prev,
          shoppingCartItems: updatedItems,
        };
        if (currentStep === 2) {
          const shoppingCartState = getShoppingCartStateInLocalStorage();
          if (shoppingCartState) {
            setShoppingCartStateInLocalStorage({
              ...shoppingCartState,
              cartDetail: newCartDetail,
            });
          }
        }
        return newCartDetail;
    });
  };

  const selectAllProducts = () => {
    setCartDetail((prevCartDetail) => {
      const allSelected = prevCartDetail.shoppingCartItems.every((item) => item.isSelected);
      return {
        ...prevCartDetail,
        shoppingCartItems: prevCartDetail.shoppingCartItems.map((item) => ({
          ...item,
          isSelected: !allSelected,
        })),
      };
    });
  };

  const goToNextStep = () => {
    if (currentStep < MAX_STEP) {
      setCurrentStep(currentStep + 1);
      window.scrollTo(0, 0);
    }
  };

  const goToPreviousStep = () => {
    if (currentStep > MIN_STEP) {
      setCurrentStep(currentStep - 1);
      window.scrollTo(0, 0);
    }
  };

  const getRealTimeLecturePrice = (item) => {
    // 1:1 real-time lectures are priced per confirmed session, not per bundle ticket
    return {
      originalPrice: sessionCount * item.price,
      discountPrice: sessionCount * item.discountPrice,
    };
  };

  const roundToTwo = (value) => {
    return Math.round((value + Number.EPSILON) * 100) / 100;
  };

  function calculatePrice() {
    // Filter selected items
    const selectedItems = cartDetail.shoppingCartItems.filter(i => i.isSelected);

    let originalTotal = 0;
    let subTotal = 0;         
    let discountTotal = 0;      
    let itemDiscountMap = {};   

    // Currency of coupon
    let couponCurrency = selectedCoupon?.currency || defaultCurrency;

    // Convert maximumDiscountValue
    const couponMaxDiscountInTarget = selectedCoupon?.maximumDiscountValue
      ? convertCurrency(selectedCoupon.maximumDiscountValue, couponCurrency, target, ratesData)
      : 0;

    // Convert discountValue for type FIXED
    const couponDiscountValueInTarget =
      selectedCoupon?.discountType === DISCOUNT_TYPES.FIXED
        ? convertCurrency(selectedCoupon.discountValue, couponCurrency, target, ratesData)
        : selectedCoupon?.discountValue || 0;

    // Determine maxDiscount in target currency
    let maxDiscount = 0;
    if (selectedCoupon && selectedCoupon.id !== 0) {
      if (selectedCoupon.discountType === DISCOUNT_TYPES.FIXED) {
        maxDiscount = couponDiscountValueInTarget;
      } else if (selectedCoupon.discountType === DISCOUNT_TYPES.PERCENTAGE) {
        maxDiscount = couponMaxDiscountInTarget || 0;
      }
    }

    // Helper: Check if coupon applies to specific item
    const canApplyCoupon = (item) => {
      if (item.isPassCovered) {
        return false;
      }

      if (
        !selectedCoupon ||
        selectedCoupon.id === 0 ||
        !selectedCoupon.targetContentType ||
        !selectedCoupon.applyFor ||
        !Array.isArray(selectedCoupon.applyFor)
      ) {
        return false;
      }

      const productCode = productTypes.find(pt => pt.id === item.productTypeId)?.code;

      return (
        (selectedCoupon.targetContentType === COUPON_TARGETS.VOD &&
          productCode === PRODUCT_TYPE_CODES.VOD_COURSE &&
          (selectedCoupon.applyFor.length === 0 || selectedCoupon.applyFor.includes(item.entityPublicId))) ||
        (selectedCoupon.targetContentType === COUPON_TARGETS.VOD_SERIES &&
          productCode === PRODUCT_TYPE_CODES.VOD_SERIES &&
          (selectedCoupon.applyFor.length === 0 || selectedCoupon.applyFor.includes(item.entityPublicId))) ||
        (selectedCoupon.targetContentType === COUPON_TARGETS.TRAINER &&
          productCode === PRODUCT_TYPE_CODES.REAL_TIME_LECTURE &&
          (selectedCoupon.applyFor.length === 0 || selectedCoupon.applyFor.includes(item.entityPublicId)))
      );
    };

    // Separate items that can use coupon
    const applicableItems = selectedItems.filter(canApplyCoupon);

    // Calculate total price of applicable items (converted to target currency)
    const getItemPrice = (item) =>
      item.isPassCovered
        ? {
            discountPrice: 0,
            originalPrice: convertCurrency(item.price, item.currencyCode ?? defaultCurrency, target, ratesData)
          }
        : isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE)
        ? {
            discountPrice: convertCurrency(getRealTimeLecturePrice(item).discountPrice, item.currencyCode ?? defaultCurrency, target, ratesData),
            originalPrice: convertCurrency(getRealTimeLecturePrice(item).originalPrice, item.currencyCode ?? defaultCurrency, target, ratesData)
          }
        : {
            discountPrice: convertCurrency(item.discountPrice, item.currencyCode ?? defaultCurrency, target, ratesData),
            originalPrice: convertCurrency(item.price, item.currencyCode ?? defaultCurrency, target, ratesData)
          };

    const getCouponBasePrice = (item) =>
      selectedCoupon?.targetContentType === COUPON_TARGETS.TRAINER && isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE)
        ? convertCurrency(item.discountPrice, item.currencyCode ?? defaultCurrency, target, ratesData)
        : getItemPrice(item).discountPrice;

    const applicableTotalPrice = applicableItems.reduce((sum, item) => sum + getCouponBasePrice(item), 0);

    // Calculate total coupon discount (respecting maxDiscount) in target currency
    let totalCouponDiscount = 0;
    if (selectedCoupon && selectedCoupon.id !== 0) {
      if (selectedCoupon.discountType === DISCOUNT_TYPES.PERCENTAGE) {
        totalCouponDiscount = roundToTwo((applicableTotalPrice * selectedCoupon.discountValue) / 100);
        if (maxDiscount > 0) totalCouponDiscount = Math.min(totalCouponDiscount, maxDiscount);
      } else if (selectedCoupon.discountType === DISCOUNT_TYPES.FIXED) {
        totalCouponDiscount = Math.min(couponDiscountValueInTarget, applicableTotalPrice);
        if (maxDiscount > 0) totalCouponDiscount = Math.min(totalCouponDiscount, maxDiscount);
      }
    }

    // Evenly distribute discount (same logic)
    const distributedDiscounts = new Map();
    applicableItems.forEach(item => distributedDiscounts.set(item.id, 0));

    let remainingDiscount = totalCouponDiscount;

    while (remainingDiscount > 0) {
      const activeItems = applicableItems.filter(item => {
        const price = getItemPrice(item).discountPrice;
        const currentDiscount = distributedDiscounts.get(item.id);
        return price > currentDiscount;
      });

      if (activeItems.length === 0) break;

      const share = roundToTwo(remainingDiscount / activeItems.length);
      let distributedThisRound = 0;

      activeItems.forEach(item => {
        const price = getItemPrice(item).discountPrice;
        const currentDiscount = distributedDiscounts.get(item.id);
        const maxPossible = price - currentDiscount;
        const applied = Math.min(share, maxPossible);

        distributedDiscounts.set(item.id, roundToTwo(currentDiscount + applied));
        distributedThisRound += applied;
      });

      remainingDiscount = roundToTwo(remainingDiscount - distributedThisRound);
      if (distributedThisRound === 0) break;
    }

    // Adjustment step
    const totalDistributed = Array.from(distributedDiscounts.values())
      .reduce((sum, val) => roundToTwo(sum + val), 0);
    const adjustDiff = roundToTwo(totalCouponDiscount - totalDistributed);

    if (Math.abs(adjustDiff) > 0) {
      const lastItemId = applicableItems[applicableItems.length - 1]?.id;
      if (lastItemId) {
        distributedDiscounts.set(
          lastItemId,
          roundToTwo(distributedDiscounts.get(lastItemId) + adjustDiff)
        );
      }
    }

    // Build final discount map for all selected items
    selectedItems.forEach(item => {
      const price = getItemPrice(item);
      const discount = distributedDiscounts.get(item.id) || 0;
      const finalPrice = roundToTwo(price.discountPrice - discount);

      originalTotal += price.originalPrice;
      subTotal += price.discountPrice;
      discountTotal += discount;

      itemDiscountMap[item.id] = {
        appliedCoupon: discount > 0 ? selectedCoupon : null,
        discount,
        originalPrice: price.discountPrice,
        finalPrice,
      };
    });

    // Final total
    const finalTotal = Math.max(subTotal - discountTotal, 0);

    return {
      originalTotal,
      subTotal,
      discountTotal,
      finalTotal,
      itemDiscountMap
    };
  }

  const goToStep = useCallback(
    (step) => {
      if (step >= SHOPPING_CART_STEPS.SHOPPING_CART && step <= SHOPPING_CART_STEPS.PAYMENT_PROGRESS && step !== currentStep) {
        setCurrentStep(step);
        window.scrollTo(0, 0);
      }
    },
    [currentStep]
  );

  useEffect(() => {
    if (defaultCoupon && !selectedCoupon) {
      setSelectedCoupon(defaultCoupon);
    }
  }, [defaultCoupon, selectedCoupon]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getProductTypes();
        setProductTypes(response);
      } catch (error) {}
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getBundleDiscounts();
        setBundleDiscounts(response);
      } catch (error) {}
    };

    fetchData();
  }, []);
  const [isRatesProcessed, setIsRatesProcessed] = useState(false);

  useEffect(() => {
    if (!ratesData || isRatesProcessed) {
      return;
    }

    const queryParams = new URLSearchParams(window.location.search);
    const quickBuy = queryParams.get("isQuickBuy") === "true";

    if (!quickBuy) {
      return;
    }

    const productId = queryParams.get("productId");
    const quickBuyItemReady = cartDetail.shoppingCartItems.some(
      (item) => item.productId === productId && item.isSelected
    );
    if (!quickBuyItemReady) return;

    const { finalTotal } = calculatePrice();

    if (finalTotal > 0) {
      setIsRatesProcessed(true);
      return;
    }

    const handleFreeProduct = async () => {
      try {
        await handlePaymentSubmit();
      } catch (error) {
        showErrorToast(translations.paymentErrorMessage);
        setIsRatesProcessed(true);
      }
    }
    handleFreeProduct();
  }, [ratesData, cartDetail.shoppingCartItems])

  useEffect(() => {
    // Subscribe to shopping cart updates
    const subscription = onShoppingCartUpdated.subscribe(async (data) => {
      const shoppingCartState = getShoppingCartStateInLocalStorage();
      if (data && !shoppingCartState && !isCartRestored.current) {
        const queryParams = new URLSearchParams(window.location.search);
        const quickBuy = queryParams.get("isQuickBuy") === "true";
        setIsQuickBuy(quickBuy);
        const productId = queryParams.get("productId");
        const quantity = queryParams.get("quantity");
        let isInCart = false;
        let quickBuyItem = null;
        if (quickBuy && productId) {
          try {
            quickBuyItem = await getQuickBuyItem(productId, quantity);
          } catch (error) {
            quickBuyItem = null;
            const rawMessage = error?.response?.data;
            const message = typeof rawMessage === "string" && rawMessage
              ? await translate(rawMessage)
              : await translate("common_ns:API_MESSAGES.EXCEPTIONS.PRODUCT_NOT_FOUND");
            if (!quickBuyErrorShown.current) {
              quickBuyErrorShown.current = true;
              showErrorToast(message);
            }
            setIsQuickBuy(false);
          }
        }
        let updatedItems = data.shoppingCartItems.map((item) => {
          let isSelected = false;
          if (quickBuy && item.productId === productId) {
            isSelected = true;
            isInCart = true;
          } else if (selectedProductIdsRef.current.includes(item.productId)) {
            isSelected = true;
          } else {
            isSelected = item.isSelected;
          }
          return isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE)
            ? {
                ...item,
                bundleDiscountOptions: (bundleDiscounts ?? []).map((bd) => ({
                  label: `${bd.numberTicket}x${display(item.discountPrice * (1 - bd.discountPercentage / 100), item.currencyCode ?? defaultCurrency, target)} / ${translations.sessionLabel}`,
                  originalLabel: `${bd.numberTicket}x${display(item.price, item.currencyCode ?? defaultCurrency, target)} / ${translations.sessionLabel}`,
                  value: bd.id,
                })),
                selectedBundleId: (bundleDiscounts ?? []).find((bd) => bd.numberTicket === item.quantity)?.id || null,
                isSelected,
                discountPercent: (bundleDiscounts ?? []).find((bd) => bd.numberTicket === item.quantity)?.discountPercentage || 0,
              }
            : { ...item, isSelected };
        });

        const a = [];
        if (quickBuy && !isInCart && quickBuyItem) {
          if (isInCart) {
            updatedItems = updatedItems.filter((item) => item.Id === quickBuyItem.Id);
          }

          updatedItems.push(isProductType(quickBuyItem.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE)
          ? {
              ...quickBuyItem,
              bundleDiscountOptions: (bundleDiscounts ?? []).map((bd) => ({
                label: `${bd.numberTicket}x${display(quickBuyItem.discountPrice * (1 - bd.discountPercentage / 100), quickBuyItem.currencyCode ?? defaultCurrency, target)} / ${translations.sessionLabel}`,
                originalLabel: `${bd.numberTicket}x${display(quickBuyItem.price, quickBuyItem.currencyCode ?? defaultCurrency, target)} / ${translations.sessionLabel}`,
                value: bd.id,
              })),
              selectedBundleId: (bundleDiscounts ?? []).find((bd) => bd.numberTicket === quickBuyItem.quantity)?.id || null,
              isSelected: true,
              discountPercent: (bundleDiscounts ?? []).find((bd) => bd.numberTicket === quickBuyItem.quantity)?.discountPercentage || 0,
              isQuickBuyItem: true
            }
          : { ...quickBuyItem, isSelected: true })
        }

        setCartDetail({ ...data, shoppingCartItems: updatedItems });
        if (quickBuy) {
          const hasMatchedItem = updatedItems.some(
            (item) => item.productId === productId && item.isSelected
          );

          if (hasMatchedItem) {
            setCurrentStep(2);
          }
        }
      }
    });

    const fetchData = async () => {
      try {
        const shoppingCartState = getShoppingCartStateInLocalStorage();
        // Initialize the SignalR connection
        if (!getShoppingCartHubConnection()) {
          await initializeShoppingCartConnection(process.env.API_ENDPOINT);
        }
        await getShoppingCart();
        getShoppingCartHubConnection().on("ShoppingCartUpdated", (data) => {
          if (data && !shoppingCartState) {
            const updatedItems = data.shoppingCartItems.map((item) => {
              let isSelected = false;
              if (selectedProductIdsRef.current.includes(item.productId)) {
                isSelected = true;
              } else {
                isSelected = item.isSelected;
              }
              return isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE)
                ? {
                    ...item,
                    bundleDiscountOptions: (bundleDiscounts ?? []).map((bd) => ({
                      label: `${bd.numberTicket}x${display(item.discountPrice * (1 - bd.discountPercentage / 100), item.currencyCode)} / ${translations.sessionLabel}`,
                      originalLabel: `${bd.numberTicket}x${display(item.price, item.currencyCode)} / ${translations.sessionLabel}`,
                      value: bd.id,
                    })),
                    selectedBundleId: (bundleDiscounts ?? []).find((bd) => bd.numberTicket === item.quantity)?.id || null,
                    isSelected,
                    discountPercent: (bundleDiscounts ?? []).find((bd) => bd.numberTicket === item.quantity)?.discountPercentage || 0,
                  }
                : { ...item, isSelected };
            });
            setCartDetail({ ...data, shoppingCartItems: updatedItems });
          }
        });
      } catch (error) {
        //console.error(error);
      }
    };

    fetchData();

    // Cleanup subscription on component unmount
    return () => subscription.unsubscribe();
  }, [isProductType, bundleDiscounts, translations.sessionLabel, display, defaultCurrency, target, lang]);

  useEffect(() => {
    if (!currentUser) return;

    const fetchStudentOrderInfo = async () => {
      try {
        const rawResponse = await getStudentOrderInfo();
        // Ensure response is always an object
        const response = (rawResponse && typeof rawResponse === "object") ? rawResponse : {};
        setStudentInfo((prev) => ({
          ...prev,
          recipientName: response.recipientName || currentUser.displayName,
          email: response.email || currentUser.email,
        }));
      } catch {
        setStudentInfo((prev) => ({
          ...prev,
          recipientName: currentUser.displayName,
          email: currentUser.email,
        }));
      }
    };

    fetchStudentOrderInfo();
  }, [currentUser]);

  useEffect(() => {
    if (isQuickBuy || cartDetail.shoppingCartItems.some(i => i.isSelected && isProductType(i.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE))) {
      setCurrentStep(SHOPPING_CART_STEPS.PAYMENT_PROGRESS);
      return;
    }

    const stepFromUrl = getStepFromUrl();
    if (cartDetail.shoppingCartItems.filter((item) => item.isSelected).length === 0) {
      setCurrentStep(SHOPPING_CART_STEPS.SHOPPING_CART);
    } else {
      setCurrentStep(stepFromUrl);
    }
  }, [cartDetail.shoppingCartItems]);

  const getStepFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const step = parseInt(params.get(CART_PAYMENT_STEP_PARAM));
    return [2].includes(step) ? step : 1;
  };

  const shoppingCartPaymentSuccessState = getShoppingCartPaymentSuccessLocalStorage();

  if (getStepFromUrl() !== 2 && shoppingCartPaymentSuccessState === false) {
    removeShoppingCartStateFromLocalStorage();
    removeShoppingCartPaymentSuccessLocalStorage();
  }

  useEffect(() => {
    const shoppingCartState = getShoppingCartStateInLocalStorage();
    if (getStepFromUrl() === 1 && !shoppingCartState?.orderNumber) removeShoppingCartStateFromLocalStorage();
    const restoreCartAndCheckPayment = async () => {
      if (shoppingCartState && translations.processPaymentFailMessage) {
        isCartRestored.current = true;
        setSelectedCoupon(shoppingCartState.selectedCoupon);
        setStudentInfo(shoppingCartState.studentInfo);
        setSelectedPaymentMethod(shoppingCartState.selectedPaymentMethod);
        setCartDetail({
          ...shoppingCartState.cartDetail,
          shoppingCartItems: shoppingCartState.cartDetail.shoppingCartItems.map((item) => {
            return isProductType(item.productTypeId, PRODUCT_TYPE_CODES.REAL_TIME_LECTURE)
              ? {
                  ...item,
                  bundleDiscountOptions: (bundleDiscounts ?? []).map((bd) => ({
                    label: `${bd.numberTicket}x${display(
                      item.discountPrice * (1 - bd.discountPercentage / 100),
                      item.currencyCode ?? defaultCurrency,
                      target
                    )} / ${translations.sessionLabel}`,
                    originalLabel: `${bd.numberTicket}x${display(item.price, item.currencyCode ?? defaultCurrency, target)} / ${translations.sessionLabel}`,
                    value: bd.id,
                  })),
                  selectedBundleId:
                    (bundleDiscounts ?? []).find((bd) => bd.numberTicket === item.quantity)?.id ||
                    null,
                  isSelected: item.isSelected,
                  discountPercent: (bundleDiscounts ?? []).find((bd) => bd.numberTicket === item.quantity)?.discountPercentage || 0,
                }
              : { ...item, isSelected: item.isSelected };
          }),
        });
      }
    };
    restoreCartAndCheckPayment();
  }, [goToStep, translations, lang, shoppingCartPaymentSuccessState, bundleDiscounts, display, defaultCurrency, target, isProductType]);

  const updateStepInUrl = useCallback((step) => {
    const params = new URLSearchParams(window.location.search);
    if (step > 1) {
      params.set(CART_PAYMENT_STEP_PARAM, step.toString());
    } else {
      params.delete(CART_PAYMENT_STEP_PARAM);
    }

    const shoppingCartState = getShoppingCartStateInLocalStorage();
    if (step === 2 && !shoppingCartState) {
      setShoppingCartStateInLocalStorage({
        cartDetail: cartDetail,
        studentInfo: studentInfo,
        selectedCoupon: selectedCoupon,
        selectedPaymentMethod: selectedPaymentMethod,
      });
    }

    if (step === 1 && !params.has(CART_PAYMENT_STEP_PARAM)) {
      removeShoppingCartStateFromLocalStorage();
    }

    const query = params.toString();
    const newUrl = query ? `${window.location.pathname}?${query}` : `${window.location.pathname}`;
    if (newUrl !== window.location.pathname + window.location.search) {
      window.history.replaceState(null, "", newUrl);
    }
  }, [cartDetail, studentInfo, selectedCoupon, selectedPaymentMethod]);

  useEffect(() => {
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }
    updateStepInUrl(currentStep);
  }, [currentStep, updateStepInUrl]);

  if (!currentUser || !ratesData) {
    return null;
  }

  const isQuickBuyFromUrl = new URLSearchParams(window.location.search).get("isQuickBuy") === "true";
  if (isQuickBuyFromUrl && !isRatesProcessed) {
    return (
      <div className="flex flex-column align-items-center justify-content-center gap-4" style={{ minHeight: "60vh" }}>
        <KeduLoading />
        <div className="keduall-typography heading-h6-normal-400 text-center">
          {translations.waitingForPaymentLabel}
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="flex align-items-center justify-content-center py-2">
        <div className="flex">
          {steps.map((step, index) => (
            <React.Fragment key={step.id}>
              <div
                className={` ${
                  step.id === SHOPPING_CART_STEPS.SHOPPING_CART && currentStep === SHOPPING_CART_STEPS.PAYMENT_PROGRESS && !isQuickBuy ? "cursor-pointer" : ""
                }`}
                onClick={() => {
                  if (currentStep === SHOPPING_CART_STEPS.PAYMENT_PROGRESS && step.id === SHOPPING_CART_STEPS.SHOPPING_CART && !isQuickBuy) {
                    goToStep(SHOPPING_CART_STEPS.SHOPPING_CART);
                  }
                }}
              >
                <div
                  className={`pc-only flex flex-column justify-content-center text-center step-content gap-spacing-3 ${
                    step.id === currentStep
                      ? "text-primary-txt-color"
                      : "text-default-txt-color"
                  }`}
                >
                  <div className="keduall-typography text-14-semibold-600">
                    {translations.step} {step.id}.
                  </div>
                  <div className="keduall-typography heading-h5-semibold-600">
                    {step.label}
                  </div>
                </div>

                {/* Mobile view */}
                <div
                  className={`mobile-only flex flex-column justify-content-center text-center step-content gap-spacing-3 ${
                    step.id === currentStep
                      ? "text-primary-txt-color"
                      : "text-default-txt-color"
                  }`}
                >
                  <div className="keduall-typography text-14-semibold-600">
                    {step.id}.<br />
                    {step.label}
                  </div>
                </div>
              </div>

              {index < steps.length - 1 && (
                <div className="step-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 34 58" fill="none">
                    <path
                      d="M4.4967 57.7502C4.004 57.7525 3.51579 57.6564 3.06073 57.4675C2.60567 57.2786 2.19292 57.0008 1.8467 56.6502C1.14445 55.9471 0.75 54.994 0.75 54.0002C0.75 53.0065 1.14445 52.0533 1.8467 51.3502L24.1967 29.0002L1.8467 6.65021C1.1843 5.93933 0.823682 4.9991 0.840823 4.0276C0.857964 3.05609 1.25153 2.12916 1.93859 1.4421C2.62566 0.755034 3.55258 0.361475 4.52409 0.344334C5.4956 0.327193 6.43582 0.687808 7.1467 1.35021L32.1467 26.3502C32.8489 27.0533 33.2434 28.0065 33.2434 29.0002C33.2434 29.994 32.8489 30.9471 32.1467 31.6502L7.1467 56.6502C6.80048 57.0008 6.38773 57.2786 5.93267 57.4675C5.47761 57.6564 4.9894 57.7525 4.4967 57.7502Z"
                      fill="#C6C6C6"
                    />
                  </svg>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
      <div className="shopping-cart">
        {currentStep === SHOPPING_CART_STEPS.SHOPPING_CART && (
          <ShoppingCart
            ref={shoppingCartRef}
            props={{
              ...props,
              productTypes,
              cartDetail,
              translations,
              calculatePrice,
              getRealTimeLecturePrice,
              handleDelete,
              goToNextStep,
              toggleProductSelection,
              selectAllProducts,
              getProductTypeClass,
              getProductTypeTag,
              isProductType,
              handleBundleChange,
              getProductNote,
            }}
          />
        )}
        {currentStep === SHOPPING_CART_STEPS.PAYMENT_PROGRESS && (
          <Payment
            props={{
              ...props,
              productTypes,
              cartDetail,
              studentInfo,
              setStudentInfo,
              selectedCoupon,
              setSelectedCoupon,
              defaultCoupon,
              calculatePrice,
              selectedPaymentMethod,
              setSelectedPaymentMethod,
              handlePaymentSubmit,
              translations,
              getBundleDiscountLabel,
              getRealTimeLecturePrice,
              sessionCount,
              setSessionCount,
              getProductTypeClass,
              getProductTypeTag,
              isProductType,
              showErrorToast,
              getProductNote,
              handleBundleChange,
              goToStep,
              bundleDiscounts
            }}
          />
        )}
      </div>
      <Toast ref={errorToast} position="bottom-right" className="keduall-toast" />
    </>
  );
}
